import script from "./AppBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBar.vue?vue&type=script&setup=true&lang=js"

import "./AppBar.vue?vue&type=style&index=0&id=32f4572c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32f4572c"]])

export default __exports__